import React from 'react';
import { skipWaitingAndReload } from '../pwa/registerServiceWorker';

type Props = {
  visible: boolean;
  onDismiss: () => void;
};

/** Shown when a new service worker is waiting (production builds). */
export const ServiceWorkerUpdateBanner: React.FC<Props> = ({ visible, onDismiss }) => {
  if (!visible) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-3 border-b border-border bg-surface-muted px-3 py-2 text-center text-sm text-fg"
    >
      <span>A new version of LaunchPoint is ready.</span>
      <button
        type="button"
        className="rounded-lg bg-primary px-3 py-1.5 text-sm font-medium text-primary-fg hover:opacity-95"
        onClick={() => skipWaitingAndReload()}
      >
        Update now
      </button>
      <button type="button" className="text-fg-muted underline hover:text-fg" onClick={onDismiss}>
        Later
      </button>
    </div>
  );
};
